PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX body: <http://purl.obolibrary.org/obo/UBERON_0013702>
PREFIX DSGraphs: <https://purl.humanatlas.io/collection/ds-graphs>
PREFIX DSGraphsExtra: <https://purl.humanatlas.io/graph/ds-graphs-enrichments>

CONSTRUCT {
  ?block rdf:type ccf:SpatialSceneNode ;
    ccf:has_registration_location ?rui_location ;
    ccf:collides_with ?anatomical_structure ;
    ccf:x_dimension ?x_dimension ;
    ccf:y_dimension ?y_dimension ;
    ccf:z_dimension ?z_dimension ;
    ccf:dimension_unit ?dimension_units .
}
FROM DSGraphs:
FROM NAMED DSGraphsExtra:
WHERE {
  ?block ccf:comes_from ?donor ;
    ccf:has_registration_location ?rui_location .
  OPTIONAL {
    ?block ccf:generates_dataset ?dataset .
  }
  OPTIONAL {
    ?block ccf:subdivided_into_sections ?section .
    OPTIONAL {
      ?section ccf:generates_dataset ?sectionDataset .
    }
  }

  ?rui_location rdf:type ccf:SpatialEntity ;
                ccf:x_dimension ?x_dimension ;
                ccf:y_dimension ?y_dimension ;
                ccf:z_dimension ?z_dimension ;
                ccf:dimension_unit ?dimension_units ;
  .
  {
    GRAPH DSGraphsExtra: {
      ?rui_location ccf:collides_with ?anatomical_structure .
    }
  }
  UNION {
    BIND(body: as ?anatomical_structure)
  }

  #{{FILTER}}
}
